export class DocumentOption {

  constructor(documentType: string, displayName: string, documentFormat: string, availableFormats: string[]) {
    this.documentType = documentType;
    this.displayName = displayName;
    this.documentFormat = documentFormat;
    this.availableFormats = availableFormats;
  }

  documentType: string;
  displayName: string;
  documentFormat: string;
  availableFormats: string[];
  lineIds!: string[];

}
